import React, { Component } from 'react';
import { routerRedux, Route, Switch } from 'dva/router';
import { ConfigProvider, Spin } from 'antd';
import { connect } from 'dva';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import enUS from 'antd/lib/locale-provider/en_US';
import koKR from 'antd/lib/locale-provider/ko_KR';
import plPL from 'antd/lib/locale-provider/pl_PL';
import jaJP from 'antd/lib/locale-provider/ja_JP';
import zhTW from 'antd/lib/locale-provider/zh_TW';
import { getRouterData } from './common/router';
import { Authorized, reloadAuthorized } from './utils/Authorized';
import { getTokenBySSOTicket } from 'src/services/gas';
import { QueryClient, QueryClientProvider } from 'react-query';
import { getAccessToken, setAccessToken, setRefreshToken } from 'utils/sessionToken';
import { getAppUrl, getSSOLoginUrl, getUrlParams } from 'utils/sso';
import "moment/dist/locale/ja";
import { getRefreshToken } from './utils/sessionToken';
import { useMaintenanceRegionsV2, useMaintenanceRegionsV3, useRobotStatus, useTenantsContext, useRobotStatusConfig, useRobotFamily } from 'src/common/gobalState';
import { getMaintenanceArea } from 'services/maintenance-area';
import { getWebappRobotStatus } from 'services/webapp';
import { StandardLocale, getLocale } from 'src/gs-utils/core/storage/LocaleManager';
import mergeOtherRobotTypes from 'src/gs-utils/core/utils/robot/mergeOtherRobotTypes';
import { getAllProductList } from 'src/services/products';
const { ConnectedRouter } = routerRedux;
const { AuthorizedRoute } = Authorized;
const SSO_TICKET_TEXT = 'sso_ticket';
const queryClient = new QueryClient();
@connect()
class ConnectedAuthorizedRoute extends Component {
  state = {
    loading: true,
  };

  async initComponent() {
	const { dispatch } = this.props;
    const accessToken = getAccessToken();
    const searchText = window.location.search;
    const ticket = getUrlParams(searchText, SSO_TICKET_TEXT);
    if (ticket) {
      try {
        const res = await getTokenBySSOTicket(ticket);
        const { data, success } = res;
        if (success) {
          const { accessToken, refreshToken } = data;
          setAccessToken(accessToken);
          setRefreshToken(refreshToken);
          reloadAuthorized();
          window.history.pushState({}, 'ui-cloud', `${getAppUrl()}`);
          await dispatch({
            type: 'login/fetchAccountInfo',
          });
          this.setState({ loading: false });
          this.getMeasureType();
          this.getMaintenanceAreas();
          this.getRobotFamily()
        }
      } catch (err) {
        dispatch({
          type: 'login/logout',
        });
      }
    } else if (accessToken) {
      await dispatch({
        type: 'login/fetchAccountInfo',
      });
      this.setState({ loading: false });
      this.getMeasureType();
      this.getMaintenanceAreas();
      this.getRobotFamily()
    } else {
      window.location.href = getSSOLoginUrl(); // ticket 不存在，且 没有token，跳转sso登录
      this.setState({ loading: false });
    }
  }

  async getMeasureType() {
    const { dispatch } = this.props;
    const [tenants] = useTenantsContext();
    const measuretype = tenants?.person?.measureType
      dispatch({
        type: "unitSetting/changeUnit",
        payload: String(measuretype)
      });
  }

  //获取运维大区
  async getMaintenanceAreas() {
    const [, setMaintenanceRegionsV2] = useMaintenanceRegionsV2();
    const [, setMaintenanceRegionsV3] = useMaintenanceRegionsV3();
    try {
      const respV2 = await getMaintenanceArea(2);
      const respV3 = await getMaintenanceArea(3);
      const { regions: maintenanceRegionsV2 } = respV2;
      const { regions: maintenanceRegionsV3 } = respV3;
      maintenanceRegionsV2.forEach(item => {
        if (maintenanceRegionsV3.some(u => u.regionCode === item.regionCode)) {
          item["isOld"] = false
        } else {
          item["isOld"] = true
        }
      })
      setMaintenanceRegionsV2(maintenanceRegionsV2)
      setMaintenanceRegionsV3(maintenanceRegionsV3)
    } catch (error) { }
  };

  //获取oss上机器状态
  async getRobotStatus() {
    const [, setRobotStatus] = useRobotStatus();
    const [, setRobotStatusConfig] = useRobotStatusConfig();
	const locale = getLocale();
    try {
      const res = await getWebappRobotStatus();
      // res 结构如 { "100": { label: {...}, color: "" }, ... }
      const robotStatus = {};
      const robotStatusConfig = {};
      Object.keys(res).forEach((key) => {
        robotStatus[key] = res[key].label?.[locale];
        // 除 label 外的字段
        const { label, ...config } = res[key];
        robotStatusConfig[key] = config;
      });
      setRobotStatus(robotStatus);
      setRobotStatusConfig(robotStatusConfig);
    } catch (error) {
      console.log("get oss file, robot status error", error);
    }
  }

  async getRobotFamily() {
    try {
      const [, setRobotFamily] = useRobotFamily();
      const res = await getAllProductList();
      console.log("res", res)
      const mergeOtherRobotTypesData = mergeOtherRobotTypes(res?.data || [])
      setRobotFamily(mergeOtherRobotTypesData);
    } catch (error) {
      console.error(error)
      throw new Error("get RobotFamily failed ")
    }
  }


  componentDidMount() {
    this.initComponent();
    this.getRobotStatus()
    
  }

  render() {
    const { loading } = this.state;
    return loading ? (
      <div
        style={{
          display: 'grid',
          width: '100vw',
          height: '100vh',
          justifyItems: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    ) : (
      <AuthorizedRoute {...this.props} />
    );
  }
}

function RouterConfig({ history, app }) {
  const routerData = getRouterData(app);
  const BasicLayout = routerData['/'].component;

  const getAntdLocale = () => {
    const locale = getLocale();
    const localeMap = {
      [StandardLocale.ZH_CN]: zhCN,
      [StandardLocale.EN_US]: enUS,
      [StandardLocale.KO_KR]: koKR,
      [StandardLocale.JA_JP]: jaJP,
      [StandardLocale.ZH_TW]: zhTW,
      [StandardLocale.PL_PL]: plPL,
    };
    return localeMap[locale] || zhCN;
  }

  return (
      <ConfigProvider
        locale={getAntdLocale()}
      >
        <QueryClientProvider client={queryClient}>
          <ConnectedRouter history={history}>
            <Switch>
              <ConnectedAuthorizedRoute path="/" render={(props) => <BasicLayout {...props} />} />
            </Switch>
          </ConnectedRouter>
        </QueryClientProvider>
      </ConfigProvider>
  );
}

export default RouterConfig;
